import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faX, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import Customers from '../../components/Customers/Customers';
import './CartPrivado.css'

const CartPrivado = () => {
    const [cartItems, setCartItems] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem('carritoPrivado');
        setCartItems(stored ? JSON.parse(stored) : []);
    }, []);

    const updateStorage = (items) => {
        setCartItems(items);
        localStorage.setItem('carritoPrivado', JSON.stringify(items));
    };

    const cambiarCantidad = (id, cantidad) => {
        const nuevos = cartItems.map(p => {
            if (p.productId === id) {
                // Encontrar el precio aplicable para la nueva cantidad
                const applicablePrice = p.productPrices.find(price => {
                    const qList = price.quantity?.split(',').map(q => parseInt(q.trim()));
                    return qList?.includes(parseInt(cantidad));
                });
                
                return { 
                    ...p, 
                    cantidad: parseInt(cantidad),
                    // Actualizar el precio si hay uno aplicable, sino mantener el precio actual
                    precio: applicablePrice ? parseFloat(applicablePrice.price) : p.precio
                };
            }
            return p;
        });
        updateStorage(nuevos);
    };

    const eliminarProducto = (id, color, talla) => {
        const filtrados = cartItems.filter(p => !(p.productId === id && p.color === color && p.talla === talla));
        updateStorage(filtrados);
    };

    const getApplicablePrice = (item) => {
        return item.productPrices.find((p) => {
            const qList = p.quantity?.split(',').map((q) => parseInt(q.trim()));
            return qList?.includes(item.cantidad);
        });
    };

    const calcularSubtotal = (item) => {
        const applicablePrice = getApplicablePrice(item);
        const unitPrice = parseFloat(applicablePrice?.price || item.precio || '0');
        return unitPrice * item.cantidad;
    };
    
    const calcularTotal = () =>
        cartItems.reduce((acc, item) => acc + calcularSubtotal(item), 0);

    const handleCrearOrdenPrivada = async (customerData) => {
        try {
            const providerId = parseInt(localStorage.getItem('providerId'));
            const productos = cartItems.map(p => ({
                productId: p.productId,
                quantity: p.cantidad,
                color: p.color,
                size: p.talla,
                unitPrice: parseFloat(p.precio),
                productName: p.nombre,
                unity: p.unidad || 'unidad',
                imageSnapshot: p.image || undefined,
            }));

            const res = await fetch('https://api.minymol.com/orders/public', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    providerId,
                    customer: customerData,
                    totalPrice: calcularTotal(),
                    items: productos,
                }),
            });

            const data = await res.json();
            if (data?.id) {
                try {
                    const providerId = parseInt(localStorage.getItem('providerId'));
                    const providerRes = await fetch(`https://api.minymol.com/providers/public/${providerId}`);

                    if (!providerRes.ok) throw new Error('Error obteniendo datos del proveedor');

                    const provider = await providerRes.json();

                    const ordenCompleta = {
                        ...data,             // Datos de la orden que devolvió el backend
                        provider,            // Info completa del proveedor
                        customer: customerData, // Info del cliente (del formulario)
                    };

                    localStorage.setItem('ordenPrivada', JSON.stringify(ordenCompleta));
                    localStorage.removeItem('carritoPrivado');

                    // Enviar notificación por WhatsApp al proveedor
                    try {
                        const shareUrl = 'https://minymol.com';
                        await fetch('https://api.minymol.com/notifications', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                channel: 'whatsapp',
                                purpose: 'new_order',
                                phoneNumber: provider.telefono,
                                data: {
                                    proveedor: provider.nombre_empresa,
                                    cliente: customerData?.nombre ?? 'Cliente',
                                    ciudad: customerData?.ciudad ?? 'Sin ciudad',
                                    departamento: customerData?.departamento ?? 'Sin departamento',
                                    orden: data.id,
                                    valor: data?.totalPrice?.toLocaleString('es-CO'),
                                    url: shareUrl,
                                },
                            }),
                        });
                    } catch (whatsappError) {
                        console.error('Error enviando notificación WhatsApp:', whatsappError);
                        // No bloquear el flujo si falla la notificación
                    }

                    // Redireccionar directamente al catálogo privado
                    window.location.href = `/catalogo-privado-iframe?providerId=${providerId}`;
                } catch (err) {
                    console.error('Error al guardar orden completa en localStorage:', err);
                    alert('Error al generar el PDF. Intenta nuevamente.');
                }
            }

        } catch (e) {
            console.error('Error creando orden privada:', e);
        }
    };


    if (cartItems.length === 0) {
        return <>
            <div className='cart-header'>
                <button className='btn btn-primary' onClick={() => window.history.back()}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
            </div>
            <div className="cart-page-empty">
                <h2>No hay productos en el carrito</h2>
            </div>
        </>;
    }

    return (
        <>
            <div className='cart-header'>
                <button className='btn btn-primary' onClick={() => window.history.back()}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
            </div>

            <div className="cart-page">
                <div className="request-all">
                    <div className="total-global">
                        <p>Total general</p>
                        <div className='prices-shower'>
                            <h1>COP</h1>
                            <h2>{calcularTotal().toLocaleString('es-CO')}</h2>
                        </div>
                    </div>
                    <button className="request-btn" onClick={() => setShowCustomerModal(true)}>
                        Solicitar pedido
                    </button>
                </div>

                <fieldset className="provider-group privado">
                    {cartItems.map((item, i) => {
                        const applicablePrice = getApplicablePrice(item);
                        const unitPrice = parseFloat(applicablePrice?.price || item.precio || 0);
                        return (
                            <div key={i} className="cart-item">
                                <div className="item-info">
                                    <div className="item-image">
                                        <img src={item.image} alt={item.nombre} />
                                    </div>
                                    <div className="item-details">
                                        <span className="product-name">{item.nombre}</span>
                                        <p className="product-variant">Talla: {item.talla || 'N/A'} | Color: {item.color || 'N/A'}</p>
                                        <span className="product-price">
                                            <p>COP</p>{unitPrice.toLocaleString('es-CO', { minimumFractionDigits: 0 })}
                                        </span>
                                    </div>
                                </div>

                                <p className="product-total">
                                    Total: ${(unitPrice * item.cantidad).toLocaleString('es-CO')}
                                </p>

                                <div className="item-controls">
                                    <select
                                        className="quantity-selector"
                                        value={item.cantidad}
                                        onChange={(e) => cambiarCantidad(item.productId, e.target.value)}
                                    >
                                        {[...new Set(item.productPrices.flatMap(pp => pp.quantity?.split(',') || []))]
                                            .map(q => q.trim()).filter(q => q).map((q, i) => (
                                                <option key={i} value={parseInt(q)}>{q}</option>
                                            ))}
                                    </select>
                                    <FontAwesomeIcon id="item-delete" icon={faTrash} onClick={() => eliminarProducto(item.productId, item.color, item.talla)} />
                                </div>
                            </div>
                        );
                    })}
                </fieldset>
            </div>

            {showCustomerModal && (
                <div className="customer-modal-overlay">
                    <div className="customer-modal-content">
                        <button className='close-modal-btn-user' onClick={() => setShowCustomerModal(false)}>
                            <FontAwesomeIcon icon={faX} />
                        </button>
                        <Customers
                            providerId={parseInt(localStorage.getItem('providerId'))}
                            onContinue={(customerData) => {
                                setShowCustomerModal(false);
                                if (customerData) handleCrearOrdenPrivada(customerData);
                            }}
                            privado={true}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default CartPrivado;
